import { render, staticRenderFns } from "./c_Creator_EditQuests_Item_BodyCodes.vue?vue&type=template&id=fe8afd20&scoped=true&"
import script from "./c_Creator_EditQuests_Item_BodyCodes.vue?vue&type=script&lang=js&"
export * from "./c_Creator_EditQuests_Item_BodyCodes.vue?vue&type=script&lang=js&"
import style0 from "./c_Creator_EditQuests_Item_BodyCodes.vue?vue&type=style&index=0&id=fe8afd20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8afd20",
  null
  
)

export default component.exports